import { ref } from 'vue'

/**
 * Composable hook
 * primary usa with <order-form-ambi>
 */

/* 
  Stav ktery indikuje odesilani formulare ajaxem
*/
const isLoading = ref(false)

export { isLoading }
